import React, { useEffect, useRef, useState } from "react";
import Sticky from "./Sticky";

const StickyWrapper = ({ title, subtitle, shopLink }) => {
  const [isSticky, setSticky] = useState(false);
  const ref = useRef(null);
  const handleScroll = () => {
    if (ref.current) {
      setSticky(ref.current.getBoundingClientRect().top <= 0);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", () => handleScroll);
    };
  }, []);
  return (
    <div className={`sticky-wrapper${isSticky ? " sticky" : ""}`} ref={ref}>
      <Sticky
        title={title}
        subtitle={`${isSticky ? "" : subtitle}`}
        shopLink={shopLink}
      />
    </div>
  );
};

export default StickyWrapper;
